// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__U9kP_","sk-bouncedelay":"spinner_sk-bouncedelay__Sl7xe","bounce1":"spinner_bounce1__LrOMr","bounce2":"spinner_bounce2___5hEF"};